import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("es");

  // 🔄 Cargar idioma guardado en localStorage al iniciar
  useEffect(() => {
    const savedLang = localStorage.getItem("selectedLanguage");
    if (savedLang) setLanguage(savedLang);
  }, []);

  const toggleLanguage = (langCode) => {
    setLanguage(langCode);
    localStorage.setItem("selectedLanguage", langCode);
  };
  // ======================================================
  // 🗣️ TRADUCCIONES COMPLETAS
  // ======================================================
  const translations = {
    // ======================================================
    // 🇪🇸 ESPAÑOL
    // ======================================================
    es: {
      home: {
        trust: "Representación de Confianza",
        mainTitle:
          "Defendemos sus derechos con estrategia, experiencia y discreción.",
        description:
          "En Legal Innova Abogados ofrecemos un enfoque integral que abarca el derecho en sus diversas ramas, así como servicios especializados en área legal, contable y desarrollo. Nuestro compromiso es brindar asesoría experta, soluciones prácticas y acompañamiento personalizado para cada desafío.",
        sectionTitle: "En Legal Innova nos encargamos de tu caso:",
        cases: [
          "¿Enfrentás una acusación penal o tenés una causa judicial abierta? Te ofrecemos acompañamiento legal especializado para afrontar tu proceso con seguridad y confianza.",
          "¿Tienes un proceso de violencia doméstica, proceso contravencional o pensiones alimentarias? Te asesoramos de la mejor manera.",
          "¿Tuviste un accidente de tránsito que te generó una lesión de por vida? Te acompañamos en tu proceso.",
        ],
        contactBtn: "Comunícate con nosotros",
        images: {
          carro: "Accidente de tránsito",
          doctor: "Procedimiento médico",
          caida: "Caída o accidente",
          familia: "Familia firmando",
        },
        bufetesTitle: "Bufetes Aliados",
        bufetesDescription:
          "Alianzas estratégicas con firmas legales de confianza.",
      },

      // ======================================================
      // ⚖️ ÁREAS DE PRÁCTICA
      // ======================================================
      practiceAreas: {
        mainTitle: "Áreas de Especialización",
        subtitle:
          "Brindamos soluciones integrales y personalizadas en diversas ramas del derecho, con excelencia profesional y atención humana.",

        buttons: {
          showMore: "Ver más",
          showLess: "Ver menos",
        },

        areas: [
          {
            key: "legal",
            title: "Legal",
            shortDescription: "Defensa, asesoría y representación legal integral.",
            detailedDescription:
              "Nuestro equipo legal ofrece acompañamiento profesional en todas las ramas del derecho, garantizando soluciones efectivas y personalizadas para cada cliente.",
            items: [
              {
                name: "Penal",
                description:
                  "Asesoría y revisión de expedientes. Representación en audiencias, juicios y procesos penales.",
              },
              {
                name: "Contencioso",
                description:
                  "Litigios y arbitrajes con análisis y defensa integral.",
              },
              {
                name: "Administrativo",
                description:
                  "Gestión de recursos y trámites administrativos.",
              },
              {
                name: "Laboral",
                description:
                  "Asesoría en relaciones laborales, conflictos y despidos.",
              },
              {
                name: "Derecho Familiar",
                description:
                  "Pensión alimentaria, guardia, régimen de visitas, violencia doméstica, entre otras.",
              },
              {
                name: "Civil",
                description:
                  "Contratos, arrendamientos, propiedad y obligaciones civiles.",
              },
              {
                name: "Agrario y Ambiental",
                description:
                  "Asistencia en temas de tierras, recursos naturales y medio ambiente.",
              },
              {
                name: "Notarial y Registral",
                description:
                  "Autenticaciones, testamentos, matrimonios, poderes y documentos notariales.",
              },
            ],
          },
          {
            key: "accounting",
            title: "Contable",
            shortDescription:
              "Asesoría contable, tributaria y financiera profesional.",
            detailedDescription:
              "Contamos con especialistas en materia contable y fiscal, brindando soporte estratégico a empresas y personas físicas para cumplir con sus obligaciones tributarias.",
            items: [
              {
                name: "Servicios Profesionales",
                description: "Asesoría fiscal y contable integral.",
              },
              {
                name: "Asesoría Contable",
                description: "Control y análisis financiero de su negocio.",
              },
              {
                name: "Impuestos Tributarios",
                description: "Gestión y declaración de impuestos.",
              },
              {
                name: "Certificación de Ingresos",
                description:
                  "Emisión de constancias y declaraciones certificadas.",
              },
              {
                name: "Flujos de Caja",
                description: "Proyección y control de ingresos y gastos.",
              },
              {
                name: "Contabilidad para PYMES",
                description:
                  "Gestión contable especializada para pequeñas y medianas empresas.",
              },
              {
                name: "Trámites ante Ministerio de Hacienda",
                description:
                  "Cumplimiento de obligaciones fiscales y declaraciones.",
              },
              {
                name: "Estudios Crediticios",
                description: "Análisis y evaluación de capacidad crediticia.",
              },
            ],
          },
          {
            key: "development",
            title: "Desarrollo",
            shortDescription:
              "Gestión, consultoría y ejecución de proyectos inmobiliarios.",
            detailedDescription:
              "Apoyamos la planificación y ejecución de proyectos inmobiliarios, garantizando cumplimiento legal, técnico y financiero en cada etapa.",
            items: [
              {
                name: "Topografía (Curvas de Nivel)",
                description:
                  "Levantamientos topográficos y planos detallados.",
              },
              {
                name: "Catastros, Avalúos y Consultorías",
                description: "Valoración y análisis técnico de propiedades.",
              },
              {
                name: "Replaneos y Obra Civil",
                description: "Ejecución y rediseño de proyectos constructivos.",
              },
              {
                name: "Administración de Propiedades",
                description: "Gestión integral de bienes inmuebles.",
              },
              {
                name: "Trámites ante Instituciones",
                description: "Gestión de permisos, licencias y registros.",
              },
              {
                name: "Venta de Propiedades",
                description: "Asesoría en compra y venta de inmuebles.",
              },
            ],
          },
          {
            key: "notarial",
            title: "Notarial",
            shortDescription:
              "Servicios notariales con transparencia y seguridad jurídica.",
            detailedDescription:
              "Ofrecemos atención ágil y profesional en todos los actos notariales, asegurando plena validez legal y confianza en cada trámite.",
            items: [
              {
                name: "Constitución de Sociedades",
                description: "Creación legal de empresas y entidades.",
              },
              { name: "Traspasos", description: "Formalización de transferencias de bienes." },
              { name: "Matrimonios", description: "Legalización y certificación de uniones civiles." },
              { name: "Poderes", description: "Otorgamiento de autorizaciones y representaciones legales." },
              { name: "Testamentos", description: "Redacción y protocolización de últimas voluntades." },
              { name: "Declaraciones Juradas", description: "Autenticación de declaraciones y actos personales." },
              { name: "Autenticación de Firmas", description: "Validación legal de documentos firmados." },
              { name: "Certificados", description: "Emisión de constancias y certificaciones notariales." },
              { name: "Actas de Asamblea", description: "Protocolización de reuniones societarias." },
              { name: "Constitución y cancelación de prendas e hipotecas", description: "Formalización de garantías reales y contratos financieros." },
            ],
          },
        ],

        philosophy: {
          title: "En Legal Innova no solo somos",
          subtitleTi: " abogados, somos sus aliados estratégicos.",
          paragraphs: [
            "Con años de experiencia en diversas ramas del derecho, nuestro equipo brinda soluciones integrales que impulsan el crecimiento y la protección de su empresa y patrimonio.",
            "Cada cliente tiene necesidades únicas. Trabajamos de manera cercana para ofrecer estrategias personalizadas que garanticen seguridad jurídica y confianza.",
            "Entendemos que cada cliente tiene necesidades únicas. Por eso, trabajamos de manera cercana para ofrecer estrategias personalizadas que garanticen seguridad jurídica y confianza.",
            "Nos comprometemos a brindar acompañamiento constante, anticipando riesgos y generando valor a través de un servicio profesional y humano.",
          ],
        },

        whyChooseUs: {
          title: "¿Por qué elegirnos?",
          cards: [
            {
              img: "/images/Servicios1.png",
              title: "Amplia Experiencia",
              desc: "Profesionales especializados con profundo conocimiento jurídico y técnico en cada área.",
            },
            {
              img: "/images/Servicios2.png",
              title: "Servicio Personalizado",
              desc: "Cada cliente es único. Ofrecemos soluciones adaptadas a sus necesidades.",
            },
            {
              img: "/images/Servicios3.png",
              title: "Ética e Integridad",
              desc: "Priorizamos la transparencia, confianza y responsabilidad profesional.",
            },
          ],
        },
      },

      // ======================================================
      // 👥 EQUIPO
      // ======================================================
      teamPage: {
        mainTitle: "¿Quiénes Somos?",
        subtitle:
          "En Legal Innova Costa Rica, somos un bufete jurídico comprometido con la excelencia, la ética y la defensa integral de los derechos de nuestros clientes. Nuestra firma está conformada por un equipo multidisciplinario de abogados con amplia experiencia en diversas ramas del derecho, lo que nos permite ofrecer soluciones legales personalizadas, estratégicas y efectivas.",
        subtitleSub:
          "Atendemos tanto a personas como a empresas, brindando asesoría, consultoría y representación legal en ámbitos como el derecho penal, civil, familiar, corporativo, laboral y más. Nuestro enfoque se basa en la confianza, la transparencia y el profesionalismo.",
        teamTitle: "Equipo Legal Innova",
        teamSubtitle:
          "Conocé a los profesionales que dan vida a Legal Innova Costa Rica. Cada uno aporta su experiencia, ética y compromiso para garantizar un servicio de excelencia.",
        members: [
          {
            name: "Lic. Jose Antonio Acevedo Díaz.",
            role: "Socio Fundador y director de Legal Innova CR",
            bio: "El Lic. Jose Antonio Acevedo Díaz es un abogado especializado en Derecho Notarial y Registral, con formación complementaria en Derecho Penal y Procesal Penal. Ha participado en cursos del Poder Judicial de Costa Rica, incluyendo Formación Básica para Personas Técnicas Judiciales y Procedimientos en Materia Penal por la Escuela Judicial. Además, cuenta con capacitación en Cobro Judicial, Pensiones Alimentarias, Violencia Doméstica y Procesos Contravencionales, así como un Bachillerato en Contaduría Pública por la UMCA. Su preparación integral le permite abordar los casos con ética, compromiso y visión estratégica, garantizando la defensa efectiva de los intereses de sus clientes.",
            image: "/images/toño.png",
          },
          {
            name: "MSc. Manuel Soto Aguilar.",
            role: "Socio fundador de Legal Innova CR",
            bio: "El MSc. Manuel Emilio Soto Aguilar es un abogado comprometido con la justicia y la docencia, licenciado en Derecho por la Universidad de Costa Rica. con énfasis en Derecho Ambiental, y Máster en Derecho Penal y Procesal Penal por el Instituto de Estudios Jurídicos de Panamá. Ha sido defensor público, miembro de la Comisión de Asuntos Indígenas del Colegio de Abogados, y panelista invitado en temas de acceso a la justicia para pueblos indígenas. Su trabajo combina la ética profesional con un enfoque humano y social del Derecho.",
            image: "/images/Manuelt.jpeg",
          },
          
          {
            name: "Lic. Ronny Romero Ruiz.",
            role: "Socio de Legal Innova CR",
            bio: "El Lic. Ronny Romero Ruiz es un abogado especializado en derecho penal y procesal penal, reconocido por su ética, compromiso y capacidad analítica. Su experiencia en litigio y asesoría le permite abordar los casos con una visión estratégica, garantizando siempre la defensa efectiva de los intereses de sus clientes.",
            image: "/images/Ronny.jpeg",
          },
        ],
        missionVision: {
          missionTitle: "Nuestra Misión",
          missionText:
            "Brindar servicios legales con excelencia, ética y compromiso, garantizando soluciones efectivas y humanas.",
          visionTitle: "Nuestra Visión",
          visionText:
            "Ser una firma de referencia en Costa Rica, reconocida por su profesionalismo, transparencia y calidad humana.",
          valuesTitle: "Nuestros Valores",
          valuesIntro: "Nos guiamos por principios que fortalecen nuestra práctica:",
          valuesList: ["Ética", "Transparencia", "Excelencia", "Compromiso", "Empatía", "Confianza"],
        },
      },

      // ======================================================
      // 📞 CONTACTO
      // ======================================================
      contact: {
        tagline: "Estamos Aquí Para Ti",
        title: "Hablemos de Tu Caso",
        subtitle:
          "Estamos listos para escucharte y ofrecerte las mejores soluciones legales adaptadas a tus necesidades.",
        cards: {
          phone: {
            title: "Contáctanos",
            desc: "Contáctate con nosotros",
            link: "Llamar Ahora",
          },
          chat: {
            title: "Escríbenos",
            desc: "Respuesta inmediata",
            link: "Iniciar Chat",
          },
          map: {
            title: "Ubicación",
            desc: "Encuéntranos fácilmente",
            link: "Ver Mapa",
          },
        },
          
        success: "✅ Mensaje enviado correctamente",
          error: "❌ Error al enviar el mensaje. Intenta nuevamente.",

        images: {
          asesoria: "Documentación Completa",
          abogado: "Asesoría Personalizada",
        },
        form: {
          title: "Envíanos un Mensaje",
          subtitle: "Completa el formulario y te contactaremos pronto.",
          nameLabel: "Nombre Completo",
          emailLabel: "Correo Electrónico",
          phoneLabel: "Teléfono",
          areaLabel: "Área de Interés",
          messageLabel: "Mensaje",
          placeholders: {
            name: "*Nombre",
            email: "*Email",
            phone: "*Número de Teléfono",
            message: "*Mensaje",
          },
          select: {
            default: "Selecciona",
            civil: "Derecho Civil",
            penal: "Derecho Penal",
            notarial: "Derecho Notarial",
            contable: "Contaduría",
            other: "Otro",
          },
          button: "Enviar Mensaje",
          disclaimer:
            "Tu información está protegida y será tratada con confidencialidad.",
        },
      },
    },






    // ======================================================
    // 🇬🇧 INGLÉS
    // ======================================================
    en: {
      home: {
        trust: "Trusted Representation",
        mainTitle:
          "We defend your rights with strategy, experience, and discretion.",
        description:
          "At Legal Innova Lawyers, we offer a comprehensive approach that covers various areas of law, as well as specialized services in legal, accounting, and development fields. Our commitment is to provide expert advice, practical solutions, and personalized support for every challenge.",
        sectionTitle: "At Legal Innova, we take care of your case:",
        cases: [
          "Are you facing criminal charges or have an open legal case? We provide specialized legal support to help you navigate your process with confidence.",
          "Do you have a domestic violence case, family dispute, or alimony process? We offer you the best legal guidance.",
          "Have you had a traffic accident that caused a permanent injury? We will accompany you throughout the process.",
        ],
        contactBtn: "Contact Us",
        images: {
          carro: "Traffic accident",
          doctor: "Medical procedure",
          caida: "Fall or accident",
          familia: "Family signing",
        },
        bufetesTitle: "Partner Law Firms",
        bufetesDescription: "Strategic alliances with trusted legal firms.",
      },

      // ======================================================
      // ⚖️ PRACTICE AREAS
      // ======================================================
      practiceAreas: {
        mainTitle: "Areas of Expertise",
        subtitle:
          "We provide comprehensive and personalized legal solutions across multiple practice areas, with professional excellence and a human approach.",
        buttons: {
          showMore: "Show more",
          showLess: "Show less",
        },
        areas: [
          {
            key: "legal",
            title: "Legal",
            shortDescription:
              "Comprehensive legal defense, advice, and representation.",
            detailedDescription:
              "Our legal team provides professional support across all branches of law, ensuring effective and personalized solutions for each client.",
            items: [
              { name: "Criminal", description: "Defense and advisory in criminal proceedings." },
              { name: "Litigation", description: "Representation in litigation and arbitration." },
              { name: "Administrative", description: "Management of administrative procedures and appeals." },
              { name: "Labor", description: "Advice on labor relations and conflicts." },
              { name: "Family Law", description: "Child support, custody, paternity, domestic violence, and more." },
              { name: "Civil", description: "Contracts, leases, and property law." },
              { name: "Agrarian & Environmental", description: "Land and environmental law advisory." },
              { name: "Notarial & Registry", description: "Marriages, divorces, powers, and other notarial acts." },
            ],
          },
          {
            key: "accounting",
            title: "Accounting",
            shortDescription:
              "Professional accounting, tax, and financial advisory.",
            detailedDescription:
              "We provide strategic accounting and tax support to individuals and companies, ensuring full compliance with financial obligations.",
            items: [
              { name: "Professional Services", description: "Comprehensive tax and accounting advisory." },
              { name: "Accounting Advisory", description: "Financial control and analysis." },
              { name: "Tax Management", description: "Tax filing and compliance." },
              { name: "Income Certification", description: "Issuance of official income certificates." },
              { name: "Cash Flow", description: "Projection and control of cash operations." },
              { name: "Accounting for SMEs", description: "Specialized accounting for small businesses." },
              { name: "Tax Procedures", description: "Handling obligations with tax authorities." },
              { name: "Credit Studies", description: "Evaluation of financial and credit capacity." },
            ],
          },
          {
            key: "development",
            title: "Development",
            shortDescription:
              "Management, consulting, and execution of real estate projects.",
            detailedDescription:
              "We assist in the planning and execution of real estate projects, ensuring legal, technical, and financial compliance at every stage.",
            items: [
              { name: "Topography (Level Curves)", description: "Topographic surveys and detailed maps." },
              { name: "Cadastres, Appraisals & Consulting", description: "Valuation and technical property assessments." },
              { name: "Replanning & Civil Works", description: "Execution and redesign of construction projects." },
              { name: "Property Management", description: "Comprehensive real estate management." },
              { name: "Institutional Procedures", description: "Management of permits and licenses." },
              { name: "Property Sales", description: "Legal advice on real estate transactions." },
            ],
          },
          {
            key: "notarial",
            title: "Notarial",
            shortDescription: "Notarial services with transparency and legal security.",
            detailedDescription:
              "We offer professional and efficient attention in all notarial acts, ensuring full legal validity and client confidence.",
            items: [
              { name: "Company Formation", description: "Legal creation of corporations and entities." },
              { name: "Transfers", description: "Formalization of asset transfers." },
              { name: "Marriages", description: "Civil marriage registration and certification." },
              { name: "Powers of Attorney", description: "Granting of legal authorizations." },
              { name: "Wills", description: "Drafting and authentication of last wills." },
              { name: "Affidavits", description: "Authentication of sworn statements." },
              { name: "Signature Authentication", description: "Validation of signed documents." },
              { name: "Certificates", description: "Issuance of official certificates." },
              { name: "Meeting Minutes", description: "Legal recording of corporate meetings." },
              { name: "Mortgages & Pledges", description: "Creation and cancellation of guarantees and securities." },
            ],
          },
        ],

        philosophy: {
          title: "At Legal Innova, we are not just",
          subtitleTi: "lawyers, we are your strategic partners.",
          paragraphs: [
            "With years of experience in multiple legal branches, our team delivers integrated solutions that promote growth and protection for your business and assets.",
            "Each client has unique needs. We work closely to develop personalized strategies that guarantee legal certainty and trust.",
            "We are committed to providing constant support, anticipating risks, and adding value through professional and human service.",
          ],
        },

        whyChooseUs: {
          title: "Why Choose Us?",
          cards: [
            { img: "/images/Servicios1.png", title: "Extensive Experience", desc: "Specialized professionals with deep legal and technical knowledge." },
            { img: "/images/Servicios2.png", title: "Personalized Service", desc: "Every client is unique — we tailor our approach to your needs." },
            { img: "/images/Servicios3.png", title: "Ethics & Integrity", desc: "We prioritize transparency, trust, and professional responsibility." },
          ],
        },
      },

      // ======================================================
      // 👥 TEAM (ENGLISH)
      // ======================================================
      teamPage: {
        mainTitle: "Who We Are",
        subtitle:
          "At Legal Innova Costa Rica, we are a law firm committed to excellence, ethics, and the integral defense of our clients’ rights. Our team is composed of multidisciplinary attorneys with extensive experience in various branches of law, allowing us to provide personalized, strategic, and effective legal solutions.",
        subtitleSub:
          "We serve both individuals and companies, offering legal advice, consultancy, and representation in criminal, civil, family, corporate, labor, and more. Our approach is based on trust, transparency, and professionalism.",
        teamTitle: "The Legal Innova Team",
        teamSubtitle:
          "Meet the professionals behind Legal Innova Costa Rica. Each brings experience, ethics, and commitment to ensure excellent service.",
        members: [
          {
            name: "Lic. Jose Antonio Acevedo Díaz",
            role: "Founding Partner and Director of Legal Innova CR",
            bio: "Lic. Jose Antonio Acevedo Díaz is a lawyer specialized in Notarial and Registry Law, with additional training in Criminal and Procedural Criminal Law. He has participated in courses offered by the Judicial Power of Costa Rica, including Basic Training for Judicial Technical Staff and Criminal Procedure by the Judicial School. Additionally, he has expertise in Judicial Collections, Alimony, Domestic Violence, and Contraventional Processes, as well as a Bachelor's degree in Public Accounting from UMCA. His comprehensive training allows him to handle cases with ethics, commitment, and strategic vision, ensuring the effective defense of his clients' interests.",
            image: "/images/toño.png",
          },
          {
            name: "MSc. Manuel Soto Aguilar",
            role: "Founding Partner of Legal Innova CR",
            bio: "MSc. Manuel Emilio Soto Aguilar is a lawyer committed to justice and education. He holds a Law degree from the University of Costa Rica with a focus on Environmental Law, and a Master’s in Criminal and Procedural Law from the Institute of Legal Studies of Panama. He has served as a public defender, a member of the Indigenous Affairs Commission of the Bar Association, and a guest panelist on access to justice for indigenous peoples. His work combines professional ethics with a human and social vision of law.",
            image: "/images/Manuelt.jpeg",
          },
          
          {
            name: "Lic. Ronny Romero Ruiz",
            role: "Partner of Legal Innova CR",
            bio: "Lic. Ronny Romero Ruiz is a lawyer specialized in criminal and procedural law, recognized for his ethics, commitment, and analytical capacity. His experience in litigation and advisory allows him to approach cases strategically, ensuring effective defense of his clients’ interests.",
            image: "/images/Ronny.jpeg",
          },
        ],
        missionVision: {
          missionTitle: "Our Mission",
          missionText:
            "To provide legal services with excellence, ethics, and commitment, ensuring effective and human-centered solutions.",
          visionTitle: "Our Vision",
          visionText:
            "To be a reference firm in Costa Rica, recognized for professionalism, transparency, and human quality.",
          valuesTitle: "Our Values",
          valuesIntro:
            "We are guided by principles that strengthen our practice:",
          valuesList: [
            "Ethics",
            "Transparency",
            "Excellence",
            "Commitment",
            "Empathy",
            "Trust",
          ],
        },
      },

      // ======================================================
      // 📞 CONTACT (ENGLISH)
      // ======================================================
      contact: {
        tagline: "We’re Here for You",
        title: "Let’s Talk About Your Case",
        subtitle:
          "We’re ready to listen and provide you with the best legal solutions tailored to your needs.",
        cards: {
          phone: {
            title: "Contact Us",
            desc: "Get in touch today",
            link: "Call Now",
          },
          chat: {
            title: "Message Us",
            desc: "Instant response",
            link: "Start Chat",
          },
          map: {
            title: "Location",
            desc: "Find us easily",
            link: "View Map",
          },
        },
        images: {
          asesoria: "Complete Documentation",
          abogado: "Personalized Advice",
        },

          success: "✅ Message sent successfully",
          error: "❌ Error sending message. Try again.",

        form: {
          title: "Send Us a Message",
          subtitle: "Fill out the form and we’ll get back to you soon.",
          nameLabel: "Full Name",
          emailLabel: "Email",
          phoneLabel: "Phone",
          areaLabel: "Area of Interest",
          messageLabel: "Message",
          placeholders: {
            name: "*Full Name",
            email: "*Email",
            phone: "*Phone Number",
            message: "*Message",
          },
          select: {
            default: "Select",
            civil: "Civil Law",
            penal: "Criminal Law",
            notarial: "Notarial Law",
            contable: "Accounting",
            other: "Other",
          },
          button: "Send Message",
          disclaimer:
            "Your information is protected and will be treated confidentially.",
        },
      },
    },
    





    // ======================================================
    // 🇬🇧 FRANCES
    // ======================================================
    fr: {
      home: {
        trust: "Représentation de Confiance",
        mainTitle: "Nous défendons vos droits avec stratégie, expérience et discrétion.",
        description:
          "Chez Legal Innova Avocats, nous offrons une approche globale couvrant les différentes branches du droit, ainsi que des services spécialisés dans les domaines juridique, comptable et du développement. Notre engagement est de fournir des conseils d’experts, des solutions pratiques et un accompagnement personnalisé pour chaque défi.",
        sectionTitle: "Chez Legal Innova, nous prenons en charge votre dossier :",
        cases: [
          "Vous faites face à des accusations pénales ou à une procédure judiciaire en cours ? Nous vous accompagnons avec une défense juridique spécialisée, assurant confiance et sécurité tout au long du processus.",
          "Vous êtes concerné par une affaire de violence domestique, une procédure familiale ou une pension alimentaire ? Nous vous offrons la meilleure orientation juridique.",
          "Vous avez eu un accident de la route ayant causé une blessure permanente ? Nous vous assistons tout au long de votre procédure pour obtenir justice.",
        ],
        contactBtn: "Contactez-nous",
        images: {
          carro: "Accident de la route",
          doctor: "Procédure médicale",
          caida: "Chute ou accident",
          familia: "Famille signant des documents",
        },
        bufetesTitle: "Cabinets Partenaires",
        bufetesDescription: "Alliances stratégiques avec des cabinets juridiques de confiance.",
      },



      // ======================================================
      // ⚖️DOMAINES DE PRATIQUE FRANCES
      // ======================================================
      practiceAreas: {
        mainTitle: "Domaines de Spécialisation",
        subtitle:
          "Nous offrons des solutions juridiques globales et personnalisées dans plusieurs branches du droit, avec excellence professionnelle et approche humaine.",

        buttons: {
          showMore: "Voir plus",
          showLess: "Voir moins",
        },

        areas: [
          {
            key: "legal",
            title: "Juridique",
            shortDescription: "Défense, conseil et représentation juridique complète.",
            detailedDescription:
              "Notre équipe juridique offre un accompagnement professionnel dans toutes les branches du droit, garantissant des solutions efficaces et adaptées à chaque client.",
            items: [
              { name: "Pénal", description: "Conseil et représentation dans les procédures pénales et judiciaires." },
              { name: "Contentieux", description: "Gestion des litiges et arbitrages, avec analyse et défense intégrale." },
              { name: "Administratif", description: "Recours et démarches administratives complètes." },
              { name: "Travail", description: "Conseil en relations de travail, licenciements et conflits professionnels." },
              { name: "Droit de la Famille", description: "Pension alimentaire, garde, violences domestiques et autres affaires familiales." },
              { name: "Civil", description: "Contrats, locations, propriété et obligations civiles." },
              { name: "Agraire et Environnemental", description: "Assistance juridique sur les questions foncières et environnementales." },
              { name: "Notarial et Registre", description: "Authentifications, testaments, mariages, pouvoirs et documents notariés." },
            ],
          },
          {
            key: "accounting",
            title: "Comptabilité",
            shortDescription: "Conseil comptable, fiscal et financier professionnel.",
            detailedDescription:
              "Nos spécialistes en comptabilité et fiscalité offrent un soutien stratégique aux entreprises et particuliers pour assurer la conformité de leurs obligations fiscales.",
            items: [
              { name: "Services Professionnels", description: "Conseil fiscal et comptable global." },
              { name: "Conseil Comptable", description: "Contrôle et analyse financière de votre entreprise." },
              { name: "Impôts et Taxes", description: "Gestion et déclaration des impôts." },
              { name: "Certification de Revenus", description: "Émission d’attestations et de déclarations certifiées." },
              { name: "Flux de Trésorerie", description: "Prévision et contrôle des entrées et sorties financières." },
              { name: "Comptabilité pour PME", description: "Gestion comptable spécialisée pour petites et moyennes entreprises." },
              { name: "Démarches auprès du Ministère des Finances", description: "Conformité aux obligations fiscales et déclarations officielles." },
              { name: "Études de Crédit", description: "Analyse et évaluation de la capacité financière et de crédit." },
            ],
          },
          {
            key: "development",
            title: "Développement",
            shortDescription: "Gestion, conseil et exécution de projets immobiliers.",
            detailedDescription:
              "Nous accompagnons la planification et la réalisation de projets immobiliers, garantissant la conformité juridique, technique et financière à chaque étape.",
            items: [
              { name: "Topographie (Courbes de Niveau)", description: "Relevés topographiques et plans détaillés." },
              { name: "Cadastre, Expertises et Consultations", description: "Évaluation et analyse technique de propriétés." },
              { name: "Replanification et Travaux Publics", description: "Exécution et redéfinition de projets de construction." },
              { name: "Gestion Immobilière", description: "Administration complète des biens immobiliers." },
              { name: "Procédures Institutionnelles", description: "Gestion des permis, licences et enregistrements." },
              { name: "Vente de Biens", description: "Conseil juridique pour l’achat et la vente de propriétés." },
            ],
          },
          {
            key: "notarial",
            title: "Notariat",
            shortDescription: "Services notariaux transparents et juridiquement sûrs.",
            detailedDescription:
              "Nous offrons un service professionnel et efficace dans tous les actes notariés, garantissant leur validité légale et la confiance du client.",
            items: [
              { name: "Constitution de Sociétés", description: "Création légale d’entreprises et d’entités." },
              { name: "Transferts", description: "Formalisation des transferts de biens." },
              { name: "Mariages", description: "Légalisation et certification des unions civiles." },
              { name: "Procurations", description: "Octroi d’autorisations et de représentations légales." },
              { name: "Testaments", description: "Rédaction et authentification des dernières volontés." },
              { name: "Déclarations Sous Serment", description: "Authentification de déclarations personnelles." },
              { name: "Authentification de Signatures", description: "Validation légale de documents signés." },
              { name: "Certificats", description: "Émission d’attestations et certificats notariés." },
              { name: "Procès-verbaux d’Assemblée", description: "Enregistrement officiel de réunions d’entreprise." },
              { name: "Constitution et mainlevée de nantissements et hypothèques", description: "Formalisation de garanties et contrats financiers." },
            ],
          },
        ],

        philosophy: {
          title: "Chez Legal Innova, nous ne sommes pas seulement",
          subtitleTi: " des avocats, nous sommes vos partenaires stratégiques.",
          paragraphs: [
            "Fort de plusieurs années d’expérience dans diverses branches du droit, notre équipe propose des solutions intégrées favorisant la croissance et la protection de votre entreprise et de votre patrimoine.",
            "Chaque client a des besoins uniques. Nous collaborons étroitement pour développer des stratégies juridiques personnalisées, garantissant sécurité et confiance.",
            "Nous nous engageons à fournir un accompagnement constant, anticipant les risques et générant de la valeur à travers un service professionnel et humain.",
          ],
        },

        whyChooseUs: {
          title: "Pourquoi Nous Choisir ?",
          cards: [
            { img: "/images/Servicios1.png", title: "Grande Expérience", desc: "Des professionnels spécialisés avec une expertise juridique et technique approfondie." },
            { img: "/images/Servicios2.png", title: "Service Personnalisé", desc: "Chaque client est unique — nous adaptons nos solutions à vos besoins." },
            { img: "/images/Servicios3.png", title: "Éthique et Intégrité", desc: "Nous privilégions la transparence, la confiance et la responsabilité professionnelle." },
          ],
        },
      },

      
      // ======================================================
      // 👥 ÉQUIPE FRANCES
      // ======================================================
      teamPage: {
        mainTitle: "Qui Sommes-Nous ?",
        subtitle:
          "Chez Legal Innova Costa Rica, nous sommes un cabinet juridique engagé envers l’excellence, l’éthique et la défense intégrale des droits de nos clients. Notre cabinet est composé d’une équipe multidisciplinaire d’avocats expérimentés dans diverses branches du droit, nous permettant d’offrir des solutions juridiques personnalisées, stratégiques et efficaces.",
        subtitleSub:
          "Nous accompagnons à la fois les particuliers et les entreprises, en offrant des services de conseil, de consultation et de représentation légale dans des domaines tels que le droit pénal, civil, familial, corporatif, du travail et bien plus encore. Notre approche repose sur la confiance, la transparence et le professionnalisme.",
        teamTitle: "Équipe Legal Innova",
        teamSubtitle:
          "Découvrez les professionnels qui donnent vie à Legal Innova Costa Rica. Chacun apporte son expérience, son éthique et son engagement afin de garantir un service d’excellence.",
        members: [
          {
            name: "Lic. Jose Antonio Acevedo Díaz.",
            role: "Associé fondateur et directeur de Legal Innova CR",
            bio: "Le Lic. Jose Antonio Acevedo Díaz est un avocat spécialisé en droit notarial et registral, avec une formation complémentaire en droit pénal et procédure pénale. Il a participé à des cours du Pouvoir judiciaire du Costa Rica, y compris la formation de base pour le personnel technique judiciaire et les procédures pénales dispensées par l'École judiciaire. De plus, il possède des compétences en recouvrement judiciaire, pensions alimentaires, violence domestique et procédures contraventionnelles, ainsi qu'une licence en comptabilité publique de l'UMCA. Sa formation complète lui permet d’aborder les dossiers avec éthique, engagement et vision stratégique, garantissant la défense efficace des intérêts de ses clients.",
            image: "/images/toño.png",
          },
          {
            name: "MSc. Manuel Soto Aguilar.",
            role: "Associé fondateur de Legal Innova CR",
            bio: "Le MSc. Manuel Emilio Soto Aguilar est un avocat passionné par la justice et l’enseignement. Licencié en droit de l’Université du Costa Rica, spécialisé en droit de l’environnement, et titulaire d’un master en droit pénal et procédural pénal de l’Institut d’études juridiques du Panama. Ancien défenseur public, membre de la Commission des affaires autochtones du Barreau des avocats et intervenant sur l’accès à la justice pour les peuples autochtones, il conjugue éthique professionnelle et vision humaine du droit.",
            image: "/images/Manuelt.jpeg",
          },
          
          {
            name: "Lic. Ronny Romero Ruiz.",
            role: "Associé de Legal Innova CR",
            bio: "Le Lic. Ronny Romero Ruiz est un avocat spécialisé en droit pénal et procédural pénal, reconnu pour son éthique, son engagement et son sens analytique. Son expérience en contentieux et en conseil lui permet d’assurer une défense efficace et stratégique des intérêts de ses clients.",
            image: "/images/Ronny.jpeg",
          },
        ],
        missionVision: {
          missionTitle: "Notre Mission",
          missionText:
            "Offrir des services juridiques d’excellence, fondés sur l’éthique et l’engagement, garantissant des solutions efficaces et humaines.",
          visionTitle: "Notre Vision",
          visionText:
            "Devenir un cabinet de référence au Costa Rica, reconnu pour son professionnalisme, sa transparence et sa qualité humaine.",
          valuesTitle: "Nos Valeurs",
          valuesIntro:
            "Nous sommes guidés par des principes qui renforcent notre pratique :",
          valuesList: [
            "Éthique",
            "Transparence",
            "Excellence",
            "Engagement",
            "Empathie",
            "Confiance",
          ],
        },
      },
      


      // ======================================================
      // 📞 CONTACTE FRANCES
      // ======================================================  
      contact: {
        tagline: "Nous sommes là pour vous",
        title: "Parlons de votre affaire",
        subtitle:
          "Nous sommes prêts à vous écouter et à vous proposer les meilleures solutions juridiques adaptées à vos besoins.",
        cards: {
          phone: {
            title: "Contactez-nous",
            desc: "Appelez-nous directement",
            link: "Appeler maintenant",
          },
          chat: {
            title: "Écrivez-nous",
            desc: "Réponse immédiate",
            link: "Démarrer le chat",
          },
          map: {
            title: "Localisation",
            desc: "Trouvez-nous facilement",
            link: "Voir la carte",
          },
        },
        success: "✅ Message envoyé avec succès",
        error: "❌ Erreur lors de l’envoi du message. Réessayez.",
        images: {
          asesoria: "Documentation complète",
          abogado: "Conseil personnalisé",
        },
        
        form: {
          title: "Envoyez-nous un message",
          subtitle: "Remplissez le formulaire et nous vous contacterons bientôt.",
          nameLabel: "Nom complet",
          emailLabel: "Adresse e-mail",
          phoneLabel: "Téléphone",
          areaLabel: "Domaine d’intérêt",
          messageLabel: "Message",
          placeholders: {
            name: "*Nom",
            email: "*E-mail",
            phone: "*Numéro de téléphone",
            message: "*Message",
          },
          select: {
            default: "Sélectionnez",
            civil: "Droit civil",
            penal: "Droit pénal",
            notarial: "Droit notarial",
            contable: "Comptabilité",
            other: "Autre",
          },
          button: "Envoyer le message",
          disclaimer:
            "Vos informations sont protégées et seront traitées en toute confidentialité.",
        },
      },
    },
  };

  // ======================================================
  // 🔁 EXPORT CONTEXT
  // ======================================================
  const value = { language, toggleLanguage, translations };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};


export const useLanguage = () => useContext(LanguageContext);